import { useEffect, useRef } from "react";

const EventScenarioModal = ({
  setEventScenarioModal,
  device,
  scenarioNum,
  setScenarioNum,
  handleEventScenarioLearnCodeModal,
}) => {
  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setEventScenarioModal(modalName);
  }, []);

  const handleSubmit = () => {
    handleEventScenarioLearnCodeModal(device);
    closeButton.current.click();
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="ForeignScenarioModal"
      tabIndex="-1"
      aria-labelledby="ForeignScenarioModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "400px" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentsNameLable">
              انتخاب سناریو
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-sm-12 col-md-6">
                <div className="mb-3">
                  <select
                    id="timerSelect"
                    className="form-select w-100"
                    data-style="btn-default"
                    disabled="disabled"
                  >
                    <option value="0" key={0}>
                      سناریو خارجی
                    </option>
                  </select>
                </div>
              </div>
              <div className="col-sm-12 col-md-6">
                <div className="mb-3">
                  <select
                    id="timerSelect"
                    className="form-select w-100"
                    data-style="btn-default"
                    value={scenarioNum}
                    onChange={(e) => setScenarioNum(e.target.value)}
                  >
                    <option value="1" key={1}>
                      1
                    </option>
                    <option value="2" key={2}>
                      2
                    </option>
                    <option value="3" key={3}>
                      3
                    </option>
                    <option value="4" key={4}>
                      4
                    </option>
                    <option value="5" key={5}>
                      5
                    </option>
                    <option value="6" key={6}>
                      6
                    </option>
                    <option value="7" key={7}>
                      7
                    </option>
                    <option value="8" key={8}>
                      8
                    </option>
                    <option value="9" key={9}>
                      9
                    </option>
                    <option value="10" key={10}>
                      10
                    </option>
                    <option value="11" key={11}>
                      11
                    </option>
                    <option value="12" key={12}>
                      12
                    </option>
                    <option value="13" key={13}>
                      13
                    </option>
                    <option value="14" key={14}>
                      14
                    </option>
                    <option value="15" key={15}>
                      15
                    </option>
                    <option value="16" key={16}>
                      16
                    </option>
                    <option value="17" key={17}>
                      17
                    </option>
                    <option value="18" key={18}>
                      18
                    </option>
                    <option value="19" key={19}>
                      19
                    </option>
                    <option value="20" key={20}>
                      20
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div>
              {/* <button
                type="button"
                className="btn btn-success-app mb-2"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeButton}
              >
                انصراف
              </button> */}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success-app me-3 mb-2"
              onClick={handleSubmit}
            >
              ثبت
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventScenarioModal;
